





































































































































































import { refund, TicketParams } from '@/store/interfaces/tickets';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'RefundTicket',
  props: {
    ticket: {
      type: Object as PropType<Omit<TicketParams, 'ticketable'> & { ticketable: refund }>,
      required: true,
    },
  },
  data() {
    return {
      showingDetail: false,
    };
  },
  methods: {
    hidden(): void {
      this.showingDetail = false;
    },
    show(): void {
      this.showingDetail = true;
    },
  },
});
